import { ADD_CART_DETAILS, ADD_ITEM_TO_CART, REMOVE_ITEM_FROM_CART, IS_REWORK, CLEAR_CART_ITEMS, CLEAR_CART_DETAILS, CHECK_VALID_MATERIAL_GROUPS_FOR_ASSET_ITEMS, UPDATE_WBS_MATERIAL_GROUPS, CLEAR_WBS_MATERIAL_GROUPS, ADD_CART_STATUS, CLEAR_CART_STATUS } from "./actions.type";
const state = {
  cart: {
    details: {},
    items: [],
  },
  cartStatus: null,
  wbsMaterialGroups: []
};
const getters = {
  cart: (state) => state.cart,
  cartStatus: (state) => state.cartStatus,
  wbsMaterialGroups: (state) => state.wbsMaterialGroups
};
const mutations = {
  [ADD_CART_DETAILS](state, details) {
    state.cart.details = {
      cartId: details.cartId,
      status: details.status,
      branchCode: details.branchCode,
      branchName: details.branchName,
      businessAreaCode: details.businessAreaCode,
      companyCode: details.companyCode,
      companyGroup: details.companyGroup,
      budgetYear: details.budgetYear,
      createDate: details.createDate,
      selectedMarketing: details.selectedMarketing,
      selectedMemo: details.selectedMemo,
      costCenterName: details.costCenterName,
      costCenterCode: details.costCenterCode,
      requestBy: details.requestBy,
      selectedWbs: details.selectedWbs,
      wbsCode: details.wbsCode,
      wbsList: details.wbsList,
      urgentRequest: details.urgentRequest,
      project: details.project,
      subject: details.subject,
      objective: details.objective,
      objectiveOptions: details.objectiveOptions,
      requestType: details.requestType,
      requestTypeOptions: details.requestTypeOptions,
      files: details.files,
      isActive: details.isActive,
      isRework: details.isRework,

      buyerEmployeeCode: details.buyerEmployeeCode,
      purchasingGroup: details.purchasingGroup,
      shipToId: details.shipToId,
      shipToContactName: details.shipToContactName,
      shipToLocation: details.shipToLocation,
      shipToCompany: details.shipToCompany,
      shipToAddress: details.shipToAddress,
      shipToTaxId: details.shipToTaxId,
      shipToContactPhone: details.shipToContactPhone,
      shipToContactExt: details.shipToContactEx,
      shipToContactFax: details.shipToContactFax,
      shipToContactEmail: details.shipToContactEmail,
      billToId: details.billToId,
      billToContactName: details.billToContactName,
      billToLocation: details.billToLocation,
      billToCompany: details.billToCompany,
      billToAddress: details.billToAddress,
      billToTaxId: details.billToTaxId,
      billToContactPhone: details.billToContactPhone,
      billToContactExt: details.billToContactExt,
      billToContactFax: details.billToContactFax,
      billToContactEmail: details.billToContactEmail,
      shipToNote: details.shipToNote,
      billToNote: details.billToNote,
    };
  },
  [ADD_CART_STATUS](state, status) {
    state.cartStatus = status;
  },
  [ADD_ITEM_TO_CART](state, item) {
    const addedItem = state.cart.items.some(
      (product) => item.catalog_item_id && product.catalog_item_id === item.catalog_item_id
    );
    if (addedItem && !item.isFromCartPage) {
      state.cart.items = state.cart.items.map((product) => {
        if (product.catalog_item_id === item.catalog_item_id) {
          // Check type before add quantity
          if (typeof item.quantity === "string")
            item.quantity = Number(item.quantity);
          if (typeof product.quantity === "string")
            product.quantity = Number(product.quantity);

          const qty = item.quantity + product.quantity;
          const qtyString = qty.toFixed(3);

          return {
            ...product,
            quantity: Number(qtyString),
          };
        }
        return product;
      });
    } else if (item.isFromCartPage) {
      delete item['isFromCartPage'];
      state.cart.items = state.cart.items.map((product) => {
        // Check type before add quantity
        if (typeof item.quantity === "string")
          item.quantity = Number(item.quantity);
        if (typeof product.quantity === "string")
          product.quantity = Number(product.quantity);

        const qty = item.quantity + product.quantity;
        const qtyString = qty.toFixed(3);

        return item.catalog_item_id && product.catalog_item_id === item.catalog_item_id
          ? { ...product, quantity: Number(qtyString) }
          : product;

      });
    } else {
      state.cart.items.push(item);
    }
  },
  [CHECK_VALID_MATERIAL_GROUPS_FOR_ASSET_ITEMS](state, flag) {
    if (flag) {
      state.cart.items = state.cart.items.map(product => {
        return {
          ...product,
          is_valid_for_asset: state.wbsMaterialGroups.some(wbs => wbs.material_group_id === product.material_group_id)
        }
      })
    } else {
      // eslint-disable-next-line no-unused-vars
      state.cart.items = state.cart.items.map(({ is_valid_for_asset, ...restOfProduct }) => restOfProduct);
    }
  },
  [REMOVE_ITEM_FROM_CART](state, id) {
    state.cart.items = state.cart.items.filter(
      (product) => product.catalog_item_id !== id
    );
  },
  [UPDATE_WBS_MATERIAL_GROUPS](state, wbsMaterialGroups) {
    state.wbsMaterialGroups = wbsMaterialGroups;
  },
  [IS_REWORK](state, flag) {
    state.cart.details.isRework = flag;
  },
  [CLEAR_CART_ITEMS](state) {
    state.cart.items = [];
  },
  [CLEAR_CART_DETAILS](state) {
    state.cart.details = {};
  },
  [CLEAR_WBS_MATERIAL_GROUPS](state) {
    state.wbsMaterialGroups = [];
  },
  [CLEAR_CART_STATUS](state) {
    state.cartStatus = null;
  }
};

const actions = {
  [ADD_CART_DETAILS]({ commit }, details) {
    commit(ADD_CART_DETAILS, details);
  },
  [ADD_CART_STATUS]({ commit }, status) {
    commit(ADD_CART_STATUS, status);
  },
  [ADD_ITEM_TO_CART]({ commit }, item) {
    commit(ADD_ITEM_TO_CART, item);
  },
  [CHECK_VALID_MATERIAL_GROUPS_FOR_ASSET_ITEMS]({ commit }, flag) {
    commit(CHECK_VALID_MATERIAL_GROUPS_FOR_ASSET_ITEMS, flag);
  },
  [REMOVE_ITEM_FROM_CART]({ commit }, id) {
    commit(REMOVE_ITEM_FROM_CART, id);
  },
  [UPDATE_WBS_MATERIAL_GROUPS]({ commit }, wbsMaterialGroups) {
    commit(UPDATE_WBS_MATERIAL_GROUPS, wbsMaterialGroups)
  },
  [IS_REWORK]({ commit }, flag) {
    commit(IS_REWORK, flag);
  },
  [CLEAR_CART_ITEMS]({ commit }) {
    commit(CLEAR_CART_ITEMS);
  },
  [CLEAR_CART_DETAILS]({ commit }) {
    commit(CLEAR_CART_DETAILS);
  },
  [CLEAR_WBS_MATERIAL_GROUPS]({ commit }) {
    commit(CLEAR_WBS_MATERIAL_GROUPS);
  },
  [CLEAR_CART_STATUS]({ commit }) {
    commit(CLEAR_CART_STATUS);
  }
};

export default { state, getters, mutations, actions };
